import {gsap} from "gsap";
import connexion from "./connexion";

const menu = {
    open: false,

    init() {

        let _this = this;
        //const modal_connexion = document.querySelector('.__connexion_modal');
        $(document).on("click", "._menu_header", function () {
            $(".__nav_menu,.ham").toggleClass("_open");
        });

        $(document).on("click", "._nav > li > a,.menu_div", function () {
            _this.closeMenu();
        });

        // if ($(".__connexion_modal").hasClass("_show")) {
        //     $(modal_connexion).addClass("_show");
        //     //_this.loadGoogleConnexion();
        // }

        // $(document).on("click", "._open_connexion", function () {
        //     $(modal_connexion).addClass("_show");
        //     //_this.loadGoogleConnexion();
        // });
    },

    closeMenu() {
        $("header").removeClass("_open");
    },

    loadGoogleConnexion() {
        //return false;
        const modal_connexion = document.querySelector('.__connexion_modal');

        // Vérifier que le modal existe avant d’y ajouter un bouton
        if (!modal_connexion) return;

        $(modal_connexion).addClass("_show");

        // Vérifier si le conteneur du bouton Google existe
        const googleContainer = modal_connexion.querySelector('#g_id_onload_modal');
        if (!googleContainer) {
            console.error("L'élément #g_id_onload_modal est introuvable.");
            return;
        }

        // Supprimer l'ancien bouton s'il existe
        let oldButton = googleContainer.querySelector('.g_id_signin');
        if (oldButton) {
            oldButton.remove();
        }

        // Créer un nouveau bouton Google Sign-In
        const newButton = document.createElement('div');
        newButton.className = 'g_id_signin';
        newButton.setAttribute('data-theme', 'outline');
        newButton.setAttribute('data-logo_alignment', 'center');
        newButton.setAttribute('data-type', 'standard');
        newButton.setAttribute('data-shape', 'pill');

        // Ajouter le bouton dans le conteneur
        googleContainer.appendChild(newButton);

        // Vérifier si Google Identity Services est bien chargé
        if (typeof google === "undefined" || typeof google.accounts === "undefined") {
            console.error("Google Identity Services n'est pas chargé.");
            return;
        }

        // Initialisation de Google (uniquement si non initialisé précédemment)
        if (!window.googleInitialized) {
            //alert("init!!");
            google.accounts.id.initialize({
                use_fedcm: true,
                client_id: "166277857704-84itjm2ggvs0p6hibk0utmhnl8fg26rj.apps.googleusercontent.com",
                callback: connexion.handleGoogleResponse, // Ton callback spécifique
                auto_select: false,
            });
            window.googleInitialized = true; // Marque Google comme initialisé
        }

        setTimeout(function(){
            google.accounts.id.renderButton(newButton, {
                theme: 'outline',
                size: 'large',
                text: 'signin_with', // "Se connecter avec Google"
                shape: 'pill'
            });

            // Optionnel : forcer l'affichage du prompt
            google.accounts.id.prompt();
        },2500);

    }

};

export default menu;
